import getConfig, { Env } from '../config';

declare global {
  class chatWidget {
    static loadChatWidget: Function;
    static hide: Function;
    static show: Function;
  }
}

export interface CognitoUser {
  username: string;
  attributes: CognitoAttributes
}

interface CognitoAttributes {
  email: string;
  name: string;
  given_name: string;
}

const config = getConfig(process.env.REACT_APP_ENV as Env);
let script: HTMLScriptElement;
class FreshChat {
  // Commented out to decommission FreshChat functionality
  static initialize = (user: CognitoUser) => {
    // console.log('FreshChat has been decommissioned and will not initialize')
    // const userId = user.username.replace('EmpowerId_', '');
    // const loadScript = new Promise(function(resolve, reject) {
    //   script = document.createElement('script');
    //   script.src = config.chat_widget;
    //   script.addEventListener('load', function() {
    //     resolve(true);
    //   });
    //   script.addEventListener('error', function(e: ErrorEvent) {
    //     reject(e);
    //   });
    //   document.body.appendChild(script);
    // });

    // loadScript.then(() => {
    //   chatWidget.loadChatWidget({
    //     debug: true,
    //     userId: userId,
    //     token: config.freshchat_token,
    //     siteId: 'Agency360',
    //     email: user.attributes.email,
    //     firstName: user.attributes.name,
    //     lastName: user.attributes.given_name
    //   });
    // }).catch((err: Error) => {
    //   console.error(err);
    // });
    
    // No-op: FreshChat has been decommissioned
    console.log('FreshChat has been decommissioned and will not initialize');
  };

  static hide = () => {
    // if (script) {
    //   chatWidget.hide();
    // }
    
    // No-op: FreshChat has been decommissioned
    console.log('FreshChat has been decommissioned and will not initialize');
  };

  static show = () => {
    // if (script) {
    //   chatWidget.show();
    // }
    
    // No-op: FreshChat has been decommissioned
    console.log('FreshChat has been decommissioned and will not initialize');
  };
}

export { FreshChat };
